"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { RefreshCw } from "lucide-react";

// Haalt de pagina periodiek opnieuw op. Tijdens een wedstrijd schrijft TRS
// ongeveer twintig regels per uur, dus elke twintig seconden kijken is ruim
// genoeg en belast de database van Gerrit nauwelijks.
const INTERVAL_MS = 20_000;

// Zonder aftelklok. Tot 2 oktober stond hier "ververst over 7s", en dat riep op
// de tribune vooral de vraag op waarom het niet om de twaalf seconden kon. Het
// verversen gaat gewoon door; wie niet wil wachten tikt het icoon aan.
export function LiveVerversen() {
  const router = useRouter();

  useEffect(() => {
    const verversen = setInterval(() => router.refresh(), INTERVAL_MS);
    return () => clearInterval(verversen);
  }, [router]);

  return (
    <button
      type="button"
      onClick={() => router.refresh()}
      aria-label="Nu verversen"
      title="Nu verversen"
      className="inline-flex size-7 items-center justify-center rounded-full border border-[#2a4a6f] text-muted-foreground transition-colors hover:text-white active:text-primary"
    >
      <RefreshCw className="size-3.5" aria-hidden />
    </button>
  );
}
